// @index('./*.ts', pp => `import { ${pp.name} } from '${pp.path}';`)
import { AllocationsQuery } from './AllocationsQuery';
import { BaseQuery } from './BaseQuery';
import { CommentaryQuery } from './CommentaryQuery';
import { DisclaimerQuery } from './DisclaimerQuery';
import { DocumentQuery } from './DocumentQuery';
import { DynamicQuery } from './DynamicQuery';
import { FundManagerQuery } from './FundManagerQuery';
import { FundManagersQuery } from './FundManagersQuery';
import { InputQuery } from './InputQuery';
import { ObjectQuery } from './ObjectQuery';
import { PropertyQuery } from './PropertyQuery';
import { Query } from './Query';
import { ResponseQuery } from './ResponseQuery';
import { StatisticQuery } from './StatisticQuery';
import { StatisticsQuery } from './StatisticsQuery';
import { TimeseriesQuery } from './TimeseriesQuery';
import { UrlQuery } from './UrlQuery';
import { ValueQuery } from './ValueQuery';
// @endindex
// @index('./*', pp => `import * as ${pp.name} from '${pp.path}';`, { "ignore": ["./*.ts", "./*.md"] })
import * as transform from './transform';
// @endindex
export {
	// @index('./*', pp => `${pp.name},`)
	AllocationsQuery,
	BaseQuery,
	CommentaryQuery,
	DisclaimerQuery,
	DocumentQuery,
	DynamicQuery,
	FundManagerQuery,
	FundManagersQuery,
	InputQuery,
	ObjectQuery,
	PropertyQuery,
	Query,
	ResponseQuery,
	StatisticQuery,
	StatisticsQuery,
	TimeseriesQuery,
	transform,
	UrlQuery,
	ValueQuery,
	// @endindex
};